// extracted by mini-css-extract-plugin
module.exports = {"figure":"asideGalleryImage_figure__a-haw"};